import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Label,
  FormGroup,
  FormText
} from 'reactstrap';

import moment from 'moment';

import ReactDatePicker from 'react-datepicker';

class DateInput extends Component {
  constructor(){
    super();

    this.state = {
      value:null
    };
  }

  componentDidMount(){
    if(this.props.defaultValue && moment(this.props.defaultValue).isValid()){
      this.setState({value:moment(this.props.defaultValue)});
    }
  }


  render(){
    const {
      label,
      name,
      placeholder,
      warning
    } = this.props;

    const {
      value
    } = this.state;

    return (
      <FormGroup>
        {label.length > 0 && (
          <Label>{label}</Label>
        )}
        <ReactDatePicker 
          name={this.props.name}
          className='form-control'
          minDate={moment()}
          selected={value} 
          placeholderText={moment().format('MM/DD/YYYY')}
          onChange={(d) => this.setState({value:d})}
        />
        {warning.length > 0 && (
          <FormText className='DangerFeedback'>{warning}</FormText>
        )}
      </FormGroup>
    )
  }
}

DateInput.propTypes = {
  placeholder:PropTypes.string,
  name:PropTypes.string,
  label:PropTypes.string,
};

DateInput.defaultProps = {
  placeholder:'',
  name:null,
  label:'',
  warning:'',
  defaultValue:''
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/shared/components/DateInput/index.js